
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6843b33090928407530492d2";
              window.beaePageSetting.pageTitle = "Get in Touch with OPENROAD - We're Here Glad to Help!"; 
              window.beaePageSetting.pageType = "section";

          let js_N0AOMR2E = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-o8c38b9ssection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-o8c38b9s',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-o8c38b9s');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-o8c38b9s: ', ex)
      };
    

      try {
        let argid = 'beae-044sfcq0block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-044sfcq0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-044sfcq0');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-044sfcq0: ', ex)
      };
    

      try {
        let argid = 'beae-rkxwz3i8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-rkxwz3i8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-rkxwz3i8');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-rkxwz3i8: ', ex)
      };
    

      try {
        let argid = 'beae-3jdr0qcbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3jdr0qcb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3jdr0qcb');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3jdr0qcb: ', ex)
      };
    

      try {
        let argid = 'beae-hzopj1mkblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hzopj1mk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hzopj1mk');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hzopj1mk: ', ex)
      };
    

      try {
        let argid = 'beae-acmeoogwblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-acmeoogw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-acmeoogw');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-acmeoogw: ', ex)
      };
    

      try {
        let argid = 'beae-q3w8ly5qsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-q3w8ly5q',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-q3w8ly5q');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-q3w8ly5q: ', ex)
      };
    

      try {
        let argid = 'beae-czcphr1mblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-czcphr1m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-czcphr1m');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-czcphr1m: ', ex)
      };
    

      try {
        let argid = 'beae-h39ps3dnblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h39ps3dn',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h39ps3dn');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h39ps3dn: ', ex)
      };
    

      try {
        let argid = 'beae-d4qkl7vfblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d4qkl7vf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d4qkl7vf');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d4qkl7vf: ', ex)
      };
    

      try {
        let argid = 'beae-hyoi8l1eblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hyoi8l1e',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hyoi8l1e');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hyoi8l1e: ', ex)
      };
    

      try {
        let argid = 'beae-tn4uolwablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tn4uolwa',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tn4uolwa');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tn4uolwa: ', ex)
      };
    

      try {
        let argid = 'beae-pylel2ggblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pylel2gg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pylel2gg');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pylel2gg: ', ex)
      };
    

      try {
        let argid = 'beae-q8063389block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-q8063389',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-q8063389');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-q8063389: ', ex)
      };
    

      try {
        let argid = 'beae-94k5h8cablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-94k5h8ca',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-94k5h8ca');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-94k5h8ca: ', ex)
      };
    

      try {
        let argid = 'beae-hu3ssze2block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hu3ssze2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hu3ssze2');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hu3ssze2: ', ex)
      };
    

      try {
        let argid = 'beae-b036lsmjblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-b036lsmj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-b036lsmj');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-b036lsmj: ', ex)
      };
    

      try {
        let argid = 'beae-e8xe4omsblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-e8xe4oms',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-e8xe4oms');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-e8xe4oms: ', ex)
      };
    

      try {
        let argid = 'beae-3mhq5cqyblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3mhq5cqy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3mhq5cqy');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3mhq5cqy: ', ex)
      };
    

      try {
        let argid = 'beae-wfved575section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wfved575',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wfved575');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wfved575: ', ex)
      };
    

      try {
        let argid = 'beae-4jljxfx3block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4jljxfx3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4jljxfx3');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4jljxfx3: ', ex)
      };
    

      try {
        let argid = 'beae-gkfjxi4ablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gkfjxi4a',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gkfjxi4a');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gkfjxi4a: ', ex)
      };
    

      try {
        let argid = 'beae-lrj1r1gpblock-tabs',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lrj1r1gp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lrj1r1gp');
        args.el = args.els[0];
        ((data) => { const prefixClass=`div[data-id=${data.id}] > .beae-tab-wrp`;let tabs=data.el.querySelectorAll(`${prefixClass} > .beae-tab-items > .beae-tab-item`),contents=data.el.querySelectorAll(`${prefixClass} > .beae-tab-contents > .beae-tab-content`),rightside=data.el.querySelectorAll(`${prefixClass} .beae-rightside`),accordions=data.el.querySelectorAll(`${prefixClass} > .beae-tab-contents > .beae-tab-content > .beae-accordion-title--mobile`),activeTab=window.outerWidth&&window.outerWidth<=768?data.activeTabMobile:data.activeTab,toggleImg=data.toggleImg,layout=data.layout,accordionMode=data.accordionMode;function resetActive(){tabs.forEach(f=>f.classList.remove("active")),contents.forEach(f=>f.classList.remove("active")),accordions.forEach(f=>f.classList.remove("active")),toggleImg&&rightside.forEach(f=>f.classList.remove("active")),contents.forEach(f=>{const b=f.querySelector(".beae-accordion-body").style;layout=="accordions"?b.maxHeight="0px":(b.transform="scaleY(0)",b.opacity="0")})}function setActive(f){tabs[f].classList.add("active"),contents[f].classList.add("active"),accordions[f].classList.add("active"),toggleImg&&rightside[f].classList.add("active");const b=contents[f].querySelector(".beae-accordion-body");if(b){const k=b.style;layout=="accordions"?k.maxHeight=data.mode.value=="builder"?"":b.scrollHeight+"px":(k.transform="scaleY(1)",k.transformOrigin="top center",k.opacity="1")}}function removeActive(f){tabs[f].classList.remove("active"),contents[f].classList.remove("active"),accordions[f].classList.remove("active"),toggleImg&&rightside[f].classList.remove("active");const b=contents[f].querySelector(".beae-accordion-body").style;layout=="accordions"?b.maxHeight="0px":(b.transform="scaleY(0)",b.opacity="0")}resetActive(),activeTab!=="none"&&accordionMode!="popup"&&setActive(activeTab),tabs.forEach((f,b)=>{f.addEventListener("click",()=>{resetActive(),setActive(b)})});const section=data.el.closest("section.beae-section");let sectionId="";section&&(sectionId=section.getAttribute("data-sectionid"));let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(f){extOptions={},console.error(f)}if(accordions.forEach((f,b)=>{f.addEventListener("click",()=>{if(accordionMode=="popup"&&data.mode.value!="builder"){const k=f.closest(".beae-tab-content");if(k){let m=document.createElement("div");m.innerHTML=`
                            <h3 class="beae-popup__content-title">${f.querySelector("span").innerHTML}</h3>
                            <div class="beae-popup__content-body ${data.id}">${k.querySelector(".beae-accordion-body").innerHTML}</div>
                            `,window.BeaePopupLibrary.createPopup(m,{layout:extOptions.layout?extOptions.layout:"right",width:extOptions.width?extOptions.width:"400px",layoutMobile:extOptions.layoutMobile?extOptions.layoutMobile:"bottom",sectionId})}}else accordionMode=="single"?(resetActive(),setActive(b)):f.classList.contains("active")?removeActive(b):setActive(b)})}),layout=="tabs"){const f=data.el.querySelector(".beae-tab-contents"),b=f.querySelectorAll(".beae-tab-content-wrp");let k=0,m=-1;b.forEach((S,B)=>{const w=S.offsetHeight;w>k&&(m=B,k=w)}),new ResizeObserver(()=>{f.style.setProperty("--beae-tabs-max-height",`${b[m].offsetHeight}px`)}).observe(b[m])} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lrj1r1gp: ', ex)
      };
    

      try {
        let argid = 'beae-dnunhws1block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-dnunhws1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-dnunhws1');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-dnunhws1: ', ex)
      };
    

      try {
        let argid = 'beae-spfg8zlcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-spfg8zlc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-spfg8zlc');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-spfg8zlc: ', ex)
      };
    

      try {
        let argid = 'beae-n773kaiyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n773kaiy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n773kaiy');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n773kaiy: ', ex)
      };
    

      try {
        let argid = 'beae-7dpb96dpblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7dpb96dp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7dpb96dp');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7dpb96dp: ', ex)
      };
    }; if (window.BEAEBASE) {js_N0AOMR2E()} else {window.BEAEPAGEJS.push(js_N0AOMR2E)} })(); 